document.addEventListener('scroll', function () {
  const header = document.getElementById('section-header');
  const headerMobileMenu = document.getElementById('header-mobile-menu');
  const body = document.body;

  // Calculate 5% of the total page height
  const scrollTrigger = document.documentElement.scrollHeight * 0.05;

  if (window.scrollY > scrollTrigger) {
    body.classList.add('scrolled');
  } else {
    body.classList.remove('scrolled');
  }
});
